import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { BrowserRouterProps, Router } from "react-router-dom";

import { createBrowserHistory } from "history";
import { bindActionCreators, Dispatch } from "redux";

import { ILocationChangeActionData } from "ui/app";
import { locationChange } from "ui/app/app.actions";

export interface IDefaultRouterProps extends BrowserRouterProps {
  locationChange: (data: ILocationChangeActionData) => void;
  children?: React.ReactNode;
}

export const DefaultRouter: React.FC<IDefaultRouterProps> = ({ children, locationChange, ...props }) => {
  const [history] = useState(() => {
    const browserHistory = createBrowserHistory({ ...props });

    const unlisten = browserHistory.listen((location, action) => {
      const actionData: ILocationChangeActionData = {
        action: action,
        location: location
      };

      locationChange(actionData);
    });

    return { browserHistory, unlisten };
  });

  useEffect(() => {
    return history.unlisten;
  }, [history]);

  return <Router history={history.browserHistory}>{children}</Router>;
};

export default connect(null, (dispatch: Dispatch) => bindActionCreators({ locationChange }, dispatch))(DefaultRouter);
